import React from "react";
import { FaBus, FaGasPump, FaCogs, FaSnowflake, FaCheckCircle, FaTimesCircle } from "react-icons/fa";

function BusDetails({ product }) {
    if (!product) return <p className="productspec-error">Məhsul detalları yüklənmir...</p>;

    const getStatus = (val, yes = "Bəli", no = "Xeyr") =>
        val === true ? yes : val === false ? no : "Bilinmir";

    const specs = [
        { label: "Marka", value: product.brandName, icon: <FaBus /> },
        { label: "Model", value: product.modelName },
        { label: "İstehsal ili", value: product.year },
        { label: "Yanacaq növü", value: product.fuelTypeName, icon: <FaGasPump /> },
        { label: "Motor gücü", value: product.horsePower },
        { label: "Mühərrik gücü", value: product.enginePower },
        { label: "Mühərrik həcmi", value: product.engineVolume },
        { label: "Sürət qutusu", value: product.transmission, icon: <FaCogs /> },
        { label: "Ötürücü tipi", value: product.driveType },
        { label: "Rəng", value: product.color },
        { label: "Oturacaq sayı", value: product.seatCount },
        { label: "Qapı sayı", value: product.doorCount },
        { label: "Kondisioner", value: getStatus(product.airConditioning), status: product.airConditioning, icon: <FaSnowflake /> },
        { label: "Yeni?", value: getStatus(product.isNew), status: product.isNew },
        { label: "Sahiblərin sayı", value: product.ownerCount },
        { label: "Texniki baxış", value: getStatus(product.hasTechnicalInspection), status: product.hasTechnicalInspection },
        { label: "Sığorta", value: getStatus(product.hasInsurance), status: product.hasInsurance },
        { label: "Qəzalı olub?", value: getStatus(product.isAccidented), status: product.isAccidented === false },
        { label: "VIN", value: product.vin },
        { label: "Bazar tipi", value: product.marketCountry },
        { label: "Şəhər", value: product.city }
    ];

    return (
        <div className="productspec-container productspec-container--automotive">
            <div className="productspec-header">
                <FaBus className="productspec-header__icon" />
                <h3 className="productspec-header__title">Avtobus Məlumatları</h3>
            </div>

            <div className="productspec-grid">
                {specs.map((spec, index) => {
                    if (!spec.value || spec.value === "Bilinmir") return null;
                    
                    return (
                        <div key={index} className="productspec-item">
                            {spec.icon && <span className="productspec-item__icon">{spec.icon}</span>}
                            <div className="productspec-item__content">
                                <span className="productspec-item__label">{spec.label}</span>
                                <span className={`productspec-item__value ${spec.status !== undefined ? (spec.status ? 'productspec-item__value--success' : 'productspec-item__value--danger') : ''}`}>
                                    {spec.status !== undefined && (
                                        spec.status ? <FaCheckCircle className="productspec-status-icon productspec-status-icon--success" /> : <FaTimesCircle className="productspec-status-icon productspec-status-icon--danger" />
                                    )}
                                    {spec.value}
                                </span>
                            </div>
                        </div>
                    );
                })}
            </div>

            {product.description && (
                <div className="productspec-description">
                    <h4 className="productspec-description__title">Əlavə Təsvir</h4>
                    <p className="productspec-description__text">{product.description}</p>
                </div>
            )}
        </div>
    );
}

export default BusDetails;